import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-85e83314"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "col-12"
}
const _hoisted_3 = {
  class: "alert alert-success d-flex align-items-center mt-3",
  role: "alert"
}
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Neue Meldung ")
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Meldung suchen ")
const _hoisted_10 = { key: 1 }

import { BmsWizard as WdwLibBmsWizard } from 'wdw-library/dist/esm/BMSWizard';
import BmsBoardDetailView from '@/components/bms/bms_board/BmsBoardDetailView.vue';
import BmsBoardList from '@/components/bms/bms_board/BmsBoardList.vue';
import BmsBoardMap from '@/components/bms/bms_board/BmsBoardMap.vue';
import BmsBoardSearch from '@/components/bms/bms_board/BmsBoardSearch.vue';
import WdwDynbox from '@/components/general/WdwDynbox.vue';
import { fetchDomainConfig } from '@/composables/general/useDomainSettings';
import { domainStore } from '@/store/domain-store';
import { messageStore } from '@/store/message-store';
import { UrlParams, useUrlSearchParams } from '@vueuse/core';
import { computed, onBeforeMount, ref } from 'vue';
import useAuthentication from '@/composables/user/useAuthentication';
import { userStore } from '@/store/user-store';


export default /*#__PURE__*/_defineComponent({
  props: { domainid: { type: Number, required: true } },
  setup(__props) {

const props = __props

// eslint-disable-next-line
//@ts-ignore
const { initStorageAuthToken } = useAuthentication();


const showDetail = ref(false);
const urlParams: UrlParams = useUrlSearchParams('hash');
const displaySearch = ref(true);
const displayCreateMessageWizard = ref(false);
const successMessage = ref('');
const zoomToDefault = ref(false);

const user = computed(() => userStore.getState().user);
const authToken = computed(() => userStore.getState().authToken);
const apiBaseUrl = process.env.VUE_APP_SERVER_BASE_URL;

function toggleSearch() {
  displaySearch.value = !displaySearch.value;
}
function setUrlParams(params: UrlParams, resetZoom?: boolean) {
  if (resetZoom) {
    zoomToDefault.value = !zoomToDefault.value;
  }

  Object.entries(params).forEach(([key, value]) => {
    if (value && value.toString() !== '') {
      urlParams[key] = value;
    } else {
      delete urlParams[key];
    }
  });
}

function deleteUrlParams(params: string[]) {
  params.forEach(param => {
    delete urlParams[param];
  });
}
function switchDetailView(params: UrlParams, switchToDetail: boolean) {
  if (!params.messageid) {
    deleteUrlParams(['detail', 'create_dialog', 'subscribe', 'messageid']);
    messageStore.setMessage(null);
    successMessage.value = '';
  } else {
    setUrlParams({ ...params, detail: '1' });
    successMessage.value = '';
  }
  showDetail.value = switchToDetail;
}
function toggleCreateMessageWizard(id?: number) {
  if (id && id !== 0) {
    switchDetailView({ messageid: id.toString() }, true);
    successMessage.value = 'Das Anliegen wurde erfolgreich gemeldet. Sie werden über den weiteren Verlauf informiert.';
  } else if (id === 0) {
    successMessage.value =
      'Das Anliegen wurde erfolgreich gemeldet und wird nun durch unsere Mitarbeiter geprüft. Sie werden über den weiteren Verlauf informiert.';
  } else {
    successMessage.value = '';
  }
  displayCreateMessageWizard.value = !displayCreateMessageWizard.value;
}
onBeforeMount(() => {
  domainStore.setDomainId(props.domainid);
  fetchDomainConfig().then(() => {
    if (urlParams.messageid && urlParams.detail) {
      switchDetailView({ messageid: urlParams.messageid }, true);
    }
  });
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (!displayCreateMessageWizard.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (successMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "check",
                  class: "flex-shrink-0 me-2"
                }),
                _createElementVNode("div", null, _toDisplayString(successMessage.value), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(BmsBoardMap, {
            params: _unref(urlParams),
            zoomToDefault: zoomToDefault.value,
            onSwitchDetailView: switchDetailView
          }, null, 8, ["params", "zoomToDefault"])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleCreateMessageWizard())),
              class: "btn btn-block btn-lg btn-wdw btn-primary"
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "comment" }),
              _hoisted_7
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              onClick: toggleSearch,
              class: "btn btn-block btn-lg btn-wdw btn-primary"
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "magnifying-glass" }),
              _hoisted_9
            ])
          ])
        ], 512), [
          [_vShow, !showDetail.value]
        ]),
        _withDirectives(_createVNode(BmsBoardSearch, {
          params: _unref(urlParams),
          toggleMinimize: displaySearch.value,
          onOnSetUrlParams: setUrlParams
        }, null, 8, ["params", "toggleMinimize"]), [
          [_vShow, !showDetail.value]
        ]),
        (showDetail.value)
          ? (_openBlock(), _createBlock(BmsBoardDetailView, {
              key: 1,
              params: _unref(urlParams),
              onGoBackToOverview: switchDetailView
            }, null, 8, ["params"]))
          : _createCommentVNode("", true),
        (!showDetail.value)
          ? (_openBlock(), _createBlock(BmsBoardList, {
              key: 2,
              params: _unref(urlParams),
              onSwitchDetailView: switchDetailView,
              onUpdateUrlParamsPageId: setUrlParams
            }, null, 8, ["params"]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
        _createVNode(WdwDynbox, {
          title: "Neue Meldung",
          config: { showControls: false },
          watermark: false
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(WdwLibBmsWizard), {
              domainid: __props.domainid,
              user: _unref(user),
              userAuthToken: _unref(authToken),
              apiBaseUrl: _unref(apiBaseUrl)
            }, null, 8, ["domainid", "user", "userAuthToken", "apiBaseUrl"])
          ]),
          _: 1
        })
      ]))
}
}

})